module.exports = __webpack_public_path__ + "img/resmed_logo.eac611ee.png";